const config = {
    API_URL: "https://api.skynyx.ai/public/api",
    // API_URL: "http://mercury.skynyxserver.com:8000/api",
};

export default config;
